import { isIOS } from './util';

function connectWebViewJavascriptBridge(callback) {
  const $bridge = isIOS()
    ? window.WKWebViewJavascriptBridge
    : window.WebViewJavascriptBridge;

  if ($bridge) {
    callback($bridge);
  } else {
    const queueName = isIOS() ? 'WKWVJBCallbacks' : 'WVJBCallbacks';

    if (window[queueName]) {
      return window[queueName].push(callback);
    }

    window[queueName] = [callback];

    if (isIOS()) {
      window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.iOS_Native_InjectJavascript &&
        window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(
          null
        );
    } else {
      document.addEventListener('WebViewJavascriptBridgeReady', function () {
        window[queueName].forEach(c => c(window.WebViewJavascriptBridge));
      });
    }
  }
}

// 调用原生方法
export const callBridgeFunc = (funcName, param, callback) => {
  if (typeof param === 'function') {
    callback = param;
    param = {};
  }

  connectWebViewJavascriptBridge($bridge => {
    $bridge.callHandler(funcName, param, callback);
  });
};

// 注册供原生调用的方法
export const registerBridgeFunc = (funcName, handler) => {
  connectWebViewJavascriptBridge($bridge => {
    $bridge.registerHandler(funcName, handler);
  });
};
